var exports = {
  "U": "xae11d333--98d025--arrow",
};

module.exports = exports;
